import { Command } from '@ckeditor/ckeditor5-core';
import SkillsModal from './skills-modal';
export default class InsertSkillsCommand extends Command {
    execute() {
        try {
            const skillsModal = new SkillsModal();
            skillsModal
                .show()
                .then((skills) => {
                this.editor.model.change((writer) => {
                    this.editor.model.insertContent(createSkills(writer, skills));
                });
            })
                .catch(() => { });
        }
        catch (error) {
            console.error(error);
        }
    }
    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'skills');
        this.isEnabled = true;
    }
}
function createSkills(writer, skills) {
    const skillsEl = writer.createElement('skills');
    writer.appendElement('heading3', skillsEl);
    skills.forEach((skill, i) => {
        const skillItemEl = writer.createElement('skillItem');
        writer.appendText(skill, skillItemEl);
        writer.append(skillItemEl, skillsEl);
    });
    return skillsEl;
}
